import React from 'react';
// @ts-ignore
import styles from './PatientLanguageBadge.module.scss';
import { User } from '../../../../graphql/graphql';

interface Props {
	user: User;
}

const PatientLanguageBadge: React.FC<Props> = ({ user }) => {
	if (user?.profile?.languageFormatted) {
		return (
			<div className={styles.wrapper}>{user.profile?.languageFormatted}</div>
		);
	}

	return <></>;
};

export default PatientLanguageBadge;
